import { Component, effect } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { CorpInputComponent, CorpInputMaskComponent } from "@corporate-tailwind/component";
import { Router, RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { OrderTrackingService } from "src/app/features/pages/order/tracking/service/order-tracking.service";

@Component({
    selector: 'app-fp-order-tracking',
    imports: [CommonModule, ReactiveFormsModule, CorpInputMaskComponent, RouterModule, TranslateModule],
    templateUrl: './fp-order-tracking.component.html',
    styleUrl: './fp-order-tracking.component.scss'
})
export class FpOrderTrackingComponent {
    formOrderTracking: FormGroup | null = null;

    formOrderCode: FormGroup = new FormGroup({
        orderCode: new FormControl('', [Validators.required])
    });

    constructor(
        public _orderTrackingService: OrderTrackingService,
        private _router: Router
    ) {
        this.formOrderTracking = this._orderTrackingService.formGroup;

        //effect pour surveiller retour orderTracking
        effect(() => {
            const loading = this._orderTrackingService.loading$();
            const data = this._orderTrackingService.orderTracking$();

            if (!loading && data) {
                this._router.navigate(['/order-page/tracking']);
            }
        });
    }

    ngOnInit() {}

    search(){
        this._orderTrackingService.load(this.formOrderCode.get('orderCode')?.value);
    }
}
